module.exports = require('lib/storage-factory')(window.localStorage)



// WEBPACK FOOTER //
// ./app/scripts/lib/storage.coffee